module.exports = __webpack_public_path__ + "static/media/d10.ce7f0853.jpg";